const baseUrl = `${process.env.REACT_APP_API_URL}`;
const Config = {
    getJourneyTravelled:`${baseUrl}/api/v1/lead-squared/get-journey`,
    getJourneyTravelledByFilter:`${baseUrl}/api/v1/lead-squared/get-journey-by-filter`,
    dropdown:`${baseUrl}/api/v1/lead-squared/get-dropdown`,
    saveAccount:`${baseUrl}/api/v1/lead-squared/save-account`,
    updateAccount:`${baseUrl}/api/v1/lead-squared/update-account`,
    accountDetails:`${baseUrl}/api/v1/lead-squared/get-account`,
    getInspectionList:`${baseUrl}/api/v1/lead-squared/get-inspection-list`,
    saveOpportunity:`${baseUrl}/api/v1/lead-squared/save-opportunity`,
    opportunityList:`${baseUrl}/api/v1/lead-squared/opportunity-list`,
    activityList:`${baseUrl}/api/v1/lead-squared/activity-list`,
    activityProposal:`${baseUrl}/api/v1/lead-squared/get-proposal-activity`,
    nextActivity:`${baseUrl}/api/v1/lead-squared/next-activity`,
    opportunityQuestion:`${baseUrl}/api/v1/lead-squared/opportunity-question`,
    getOpportunity:`${baseUrl}/api/v1/lead-squared/get-opportunity`,
    updateOpportunity:`${baseUrl}/api/v1/lead-squared/update-opportunity`,
    accountById:`${baseUrl}/api/v1/lead-squared/get-account-by-id`,
    checkCloseOrDropped:`${baseUrl}/api/v1/lead-squared/check-opportunity-closed-or-dropped`,
    fetchReportee:`${baseUrl}/api/v1/lead-squared/get-assignee`,
    saveLead:`${baseUrl}/api/v1/lead-squared/save-lead`,
    getLeadById:`${baseUrl}/api/v1/lead-squared/get-lead-by-id`,
    getLead:`${baseUrl}/api/v1/lead-squared/lead-list`,
    accountFilter:`${baseUrl}/api/v1/lead-squared/account-filter-content`,
    leadFilter:`${baseUrl}/api/v1/lead-squared/lead-filter-content`,
    fetchCityByStateId:`${baseUrl}/api/v1/lead-squared/fetch-city`,
    leadActivities:`${baseUrl}/api/v1/lead-squared/fetch-activities`,
    leadActivitiesById:`${baseUrl}/api/v1/lead-squared/fetch-lead_activity`,
    accountActivitiesById:`${baseUrl}/api/v1/lead-squared/fetch-account-activity`,
    saveLeadOrAccountActivitiesById:`${baseUrl}/api/v1/lead-squared/save-lead_or_account_activity`,
    createSiteInspectionForm: `${baseUrl}/api/v1/sales/lead/createSiteInspectionForm`,
    getAllCity: `${baseUrl}/api/v1/sales/fetchGeoCities`,
    inspectionCreated: `${baseUrl}/api/v1/sales/lead/inspectionCreated`,
    getInspectionForm : `${baseUrl}/api/v1/maintenance/getInspectionForm`,
    opportunityFilterContent:`${baseUrl}/api/v1/lead-squared/opportunity-filter-content`,
    activityById:`${baseUrl}/api/v1/lead-squared/activity-by-id`,
    HomePageContent:`${baseUrl}/api/v1/lead-squared/home-page-content`,
    lastTenDaysInactiveAccount:`${baseUrl}/api/v1/lead-squared/last-ten-days-inactive-account`,
    saveNewActivity:`${baseUrl}/api/v1/lead-squared/save-new-activity`,
    cancelActivity:`${baseUrl}/api/v1/lead-squared/cancel-activity`,
    accountDetailsForTask:`${baseUrl}/api/v1/lead-squared/account-details`,
    saveTask:`${baseUrl}/api/v1/lead-squared/save-task`,
    updateTask:`${baseUrl}/api/v1/lead-squared/update-task`,
    removeTask:`${baseUrl}/api/v1/lead-squared/remove-task`,
    taskTypes:`${baseUrl}/api/v1/lead-squared/task-types`,
    taskById:`${baseUrl}/api/v1/lead-squared/get-task-by-id`,
    taskListing:`${baseUrl}/api/v1/lead-squared/task-listing`,
    taskFilter:`${baseUrl}/api/v1/lead-squared/task-filter`,
    notification:`${baseUrl}/api/v1/lead-squared/get-notification`,
    readNotification:`${baseUrl}/api/v1/lead-squared/read-notification`,
    getProfile:`${baseUrl}/api/v1/getProfile`,
    changeAssignee:`${baseUrl}/api/v1/lead-squared/change-assignee`,
    dealerListingForAssignee:`${baseUrl}/api/v1/lead-squared/ucd-dealer-listing-assignee`,
    getDealerApprovedListing: `${baseUrl}/api/v1/lead-squared/dealer-approved-list`,
    reassignDealerManager:`${baseUrl}/api/v1/lead-squared/reassign-dealer-manager`,
    assigneeAccount:`${baseUrl}/api/v1/lead-squared/account-assignee`,
    rejectActivity:`${baseUrl}/api/v1/lead-squared/reject-activity`,
    stateAndRegion:`${baseUrl}/api/v1/lead-squared/state-region`,
    distanceFromSite:`${baseUrl}/api/v1/lead-squared/distance-from-site`,
    ProposalCommercialClosure:`${baseUrl}/api/v1/lead-squared/proposal-commercial-closure`,
    maintenanceCost:`${baseUrl}/api/v1/lead-squared/maintenance-cost`,
    getDetails:`${baseUrl}/api/v1/lead-squared/get-dealer`,
    dealerProfileData:`${baseUrl}/api/v1/lead-squared/dealer-profile-data`,
    attendance:`${baseUrl}/api/v1/lead-squared/mark-attendance`,
    attendanceDealerLead:`${baseUrl}/api/v1/lead-squared/mark-dealer-lead-attendance`,
    moduleActivity:`${baseUrl}/api/v1/lead-squared/get-dealer-activity`,
    moduleDealerLeadActivity:`${baseUrl}/api/v1/lead-squared/get-dealer-lead-activity`,
    isUserCheckout:`${baseUrl}/api/v1/lead-squared/is-user-checkin`,
    isUserDealerLeadCheckout:`${baseUrl}/api/v1/lead-squared/is-user-lead-checkin`,
    dealerActivityTypes:`${baseUrl}/api/v1/lead-squared/dealer-activity-types`,
    saveActivityOnModules:`${baseUrl}/api/v1/lead-squared/save-activity-modules`,
    saveActivityOnDealerLead:`${baseUrl}/api/v1/lead-squared/save-dealer-lead-activity`,
    dearlerById:`${baseUrl}/api/v1/lead-squared/dealer-by-id`,
    leadGateTypes:`${baseUrl}/api/v1/lead-squared/lead-gate-type`,
    rescheduleActivity:`${baseUrl}/api/v1/lead-squared/reschedule-activity`,
    getSenior:`${baseUrl}/api/v1/lead-squared/get-senior`,
    UpdateTaggedAlong:`${baseUrl}/api/v1/lead-squared/update-tagged-along`,
    taggedAlongList:`${baseUrl}/api/v1/lead-squared/tagged-along-list`,
    taggedAlongById:`${baseUrl}/api/v1/lead-squared/tagged-along-by-id`,
    addTaggedAlong:`${baseUrl}/api/v1/lead-squared/add-tagged_along`,
    activityFilter:`${baseUrl}/api/v1/lead-squared/activity-filter`,
    homeFilter:`${baseUrl}/api/v1/lead-squared/home-filter`,
    v2OpportunityActivity:`${baseUrl}/api/v1/lead-squared/opportunity-v2-activity`,
    lastLeadOpportunityActivity:`${baseUrl}/api/v1/lead-squared/last-lead-opportunity-activity`,
    userCheckInForModule:`${baseUrl}/api/v1/lead-squared/is-user-check-in-for-module`,
    meetingRating:`${baseUrl}/api/v1/lead-squared/meeting-rating`,
    userRating: `${baseUrl}/api/v1/lead-squared/user-rating-hod`,
    juniorListingForHod:`${baseUrl}/api/v1/lead-squared/junior-list-for-hod`,
    starCheck:`${baseUrl}/api/v1/lead-squared/star-check`,
    emailDropdown:`${baseUrl}/api/v1/lead-squared/email-dropdown`,
    selfRatingDetails:`${baseUrl}/api/v1/lead-squared/self-rating-details`,
    smByUserId:`${baseUrl}/api/v1/lead-squared/sm-detail-by-user-id`,
    rmViewDetails:`${baseUrl}/api/v1/lead-squared/rm-view-details`,
    selectedTaggedAlong:`${baseUrl}/api/v1/lead-squared/selected-tagged-along`,
    searchDealerMaster:`${baseUrl}/api/v1/lead-squared/search-dealer-master`,
    dealerHeathCard:`${baseUrl}/api/v1/lead-squared/dealer-health-card`,
    UCDVerify:`${baseUrl}/api/v1/lead-squared/verify-ucd-dealer`,
    UCDDealerById:`${baseUrl}/api/v1/lead-squared/ucd-dealer-id`,
    ucdSave:`${baseUrl}/api/v1/lead-squared/ucd-dealer-save`,
    ucdUpdate:`${baseUrl}/api/v1/lead-squared/ucd-dealer-update`,
    otpGenerate:`${baseUrl}/api/v1/lead-squared/otp-generate`,
    ucdList:`${baseUrl}/api/v1/lead-squared/ucd-list`,
    firmTypes:`${baseUrl}/api/v1/lead-squared/firm-type`,
    getDealerPoc:`${baseUrl}/api/v1/lead-squared/get-dealer-poc`,
    updateDealerPoc:`${baseUrl}/api/v1/lead-squared/update-dealer-poc`,
    pendingLeads:`${baseUrl}/api/v1/lead-squared/lead-pending-list`,
    leadApproval:`${baseUrl}/api/v1/lead-squared/lead-approval`,
    carBrand: `${baseUrl}/api/v1/lead-squared/car-brand`,
    carModel: `${baseUrl}/api/v1/lead-squared/car-model`,
    carVariant: `${baseUrl}/api/v1/lead-squared/car-variant`,
    bankList: `${baseUrl}/api/v1/lead-squared/bank-list`,
    newCase: `${baseUrl}/api/v1/lead-squared/ucd-cases`,
    caseByLsqDealerId: `${baseUrl}/api/v1/lead-squared/case-by-dealer-id`,
    updateCaseStatus: `${baseUrl}/api/v1/lead-squared/update-ucd-case-status`,
    caseListing: `${baseUrl}/api/v1/lead-squared/cases-list`,
    caseById: `${baseUrl}/api/v1/lead-squared/cases-by-id`,
    loanApplicationById: `${baseUrl}/api/v1/lead-squared/loan-application-by-id`,
    loanApplicationUpdate: `${baseUrl}/api/v1/lead-squared/loan-application-update`,
    leadAddressApprovalList: `${baseUrl}/api/v1/lead-squared/lead-address-approval-list`,
    leadAddressPendingById: `${baseUrl}/api/v1/lead-squared/lead-address-approval-by-id`,
    leadAddressApprovalAction: `${baseUrl}/api/v1/lead-squared/lead-address-approval`,
    addressUpdateLogs: `${baseUrl}/api/v1/lead-squared/address-update-logs`,
    raisePayment: `${baseUrl}/api/v1/lead-squared/payment-raise`,
    loanAccount: `${baseUrl}/api/v1/lead-squared/loan-account-details`,
    loanUndertaking: `${baseUrl}/api/v1/lead-squared/loan-undertaking`,
    approvalRequest: `${baseUrl}/api/v1/lead-squared/request-approval`,
    loanTranches: `${baseUrl}/api/v1/lead-squared/loan-tranches`,
    raisePaymentUpdate: `${baseUrl}/api/v1/lead-squared/payment-raise-update`,
    payoutDetailsUpdate: `${baseUrl}/api/v1/lead-squared/payout-details-update`,
    getPayoutDetails: `${baseUrl}/api/v1/lead-squared/get-payout-details`,
    newBankDetails: `${baseUrl}/api/v1/lead-squared/ucd-v2-bank-list`,
    updateTrancheStatus: `${baseUrl}/api/v1/lead-squared/loan-tranche-update-status`,
    foreClosureAccountDetails: `${baseUrl}/api/v1/lead-squared/fore-closure-account-details`,
    vehicleDetails: `${baseUrl}/api/v1/lead-squared/vehicle-details`,
    agreementNotification: `${baseUrl}/api/v1/lead-squared/ucd-agreement-notification`,
    checkAgreementVerified: `${baseUrl}/api/v1/lead-squared/check-agreement-verified`,
    rcCaseById: `${baseUrl}/api/v1/lead-squared/rc-case-by-id`,

    FasttagTollActivityType:`${baseUrl}/api/v1/lead-squared/fasttag-toll-activity`,
    FasttagTollActivitySave:`${baseUrl}/api/v1/lead-squared/fasttag-toll-activity-save`,
    FasttagTollPendingActivity:`${baseUrl}/api/v1/lead-squared/fasttag-toll-pending-activity`,
    FasttagTollAttendance:`${baseUrl}/api/v1/lead-squared/fasttag-toll-attendance`,
    FasttagTollIsCheckout:`${baseUrl}/api/v1/lead-squared/fasttag-toll-is_checkout`,
    FasttagTollSave:`${baseUrl}/api/v1/lead-squared/save-fast-tag-toll`,
    FasttagTollAccountList:`${baseUrl}/api/v1/lead-squared/list-account-fast-tag-toll`,
    tollById:`${baseUrl}/api/v1/lead-squared/fast-tag-toll-by-id`,
    tollFilter:`${baseUrl}/api/v1/lead-squared/fast-tag-toll-filter`,
    tollApprovePending:`${baseUrl}/api/v1/lead-squared/fast-tag-toll-approval-list`,
    tollActivityApprove:`${baseUrl}/api/v1/lead-squared/fast-tag-toll-approval`,
    FSEDetails:`${baseUrl}/api/v1/lead-squared/get-fse`,
    AMByAsm:`${baseUrl}/api/v1/lead-squared/get-am`,
    AmToll:`${baseUrl}/api/v1/lead-squared/get-am-toll`,
    AmTollMonthlyPlan:`${baseUrl}/api/v1/lead-squared/am-monthly-plan`,
    PJPReview:`${baseUrl}/api/v1/lead-squared/pjp-plan_review`,
    PJPPendingList:`${baseUrl}/api/v1/lead-squared/pjp-pending-list`,
    PJPPendingApprove:`${baseUrl}/api/v1/lead-squared/pjp-approve`,
    fseOTPGeneration:`${baseUrl}/api/v1/lead-squared/fse-otp`,
    saveFSEs:`${baseUrl}/api/v1/lead-squared/save-fse`,
    FSEsDetailsByPJPId:`${baseUrl}/api/v1/lead-squared/fse-details`,
    pjpDetailsById:`${baseUrl}/api/v1/lead-squared/pjp-details-by-id`,
    inactiveFseDetails:`${baseUrl}/api/v1/lead-squared/toll-fse-details`,
    fseActivationCheck:`${baseUrl}/api/v1/lead-squared/fse-activation-status`,
    fseInventory:`${baseUrl}/api/v1/lead-squared/fse-inventory-given`,
    fseTagTransfer:`${baseUrl}/api/v1/lead-squared/fse-tag-transfer`,
    callLogs:`${baseUrl}/api/v1/lead-squared/toll-call-logs`,
    getAllDays:`${baseUrl}/api/v1/darwin-work/get-all-days`,
    saveAttendanceRegularization: `${baseUrl}/api/v1/darwin-work/save-attendance-regularization-request`,
    getRegularizationDetails:`${baseUrl}/api/v1/darwin-work/get-regularization-details`,
    markNonSiteCheckIn:`${baseUrl}/api/v1/darwin-work/mark-not-at-site-check-in`,
    updateRegularizationDetails:`${baseUrl}/api/v1/darwin-work/update-attendance-regularization`,
    getRegularizationFilter:`${baseUrl}/api/v1/darwin-work/get-regularization-filter`,
    getAttendanceDetails:`${baseUrl}/api/v1/darwin-work/get-attendance-details`,
    getMonthsFilter:`${baseUrl}/api/v1/darwin-work/get-months-filter`,
    meetingDataForParticularDate: `${baseUrl}/api/v1/darwin-work/meeting-data-for-particular-date`,
    markNonSiteCheckOut:`${baseUrl}/api/v1/darwin-work/mark-not-at-site-check-out`,
    tollPendingMeeting:`${baseUrl}/api/v1/lead-squared/toll-pending-meeting`,
    errorLogs:`${baseUrl}/api/v1/lead-squared/error-logs`,
    nearestPlazaFromOperatorLocation:`${baseUrl}/api/v1/lead-squared/nearest-plaza-from-operator-location`,
    checkSBIIssuance:`${baseUrl}/api/v1/lead-squared/check-sbi-issuance`,

    valetAccountSave:`${baseUrl}/api/v1/lead-squared/valet-account_save`,
    valetAccountList:`${baseUrl}/api/v1/lead-squared/valet-account-list`,
    valetAccountById:`${baseUrl}/api/v1/lead-squared/valet-account-by-id`,
    valetActivitySave:`${baseUrl}/api/v1/lead-squared/valet-activity-save`,
    valetAccountFilter:`${baseUrl}/api/v1/lead-squared/valet-account-filter`,
    valetPendingActivity:`${baseUrl}/api/v1/lead-squared/valet-pending-activity`,
    existingSite:`${baseUrl}/api/v1/lead-squared/valet-operation-project`,
    siteVisitValet:`${baseUrl}/api/v1/lead-squared/valet-site_visit`,
    siteVisitValetList:`${baseUrl}/api/v1/lead-squared/get-site-visit-list`,
    valetOperationProjectById:`${baseUrl}/api/v1/lead-squared/get-valet-operation-project-by-id`,
    meetingMomSend: `${baseUrl}/api/v1/lead-squared/create-mom`,
    momList: `${baseUrl}/api/v1/lead-squared/mom-list`,
    momById: `${baseUrl}/api/v1/lead-squared/mom-by-id`,
    externalMomList: `${baseUrl}/api/v1/lead-squared/external-mon-listing`,

    CarServiceActivityType:`${baseUrl}/api/v1/lead-squared/fasttag-toll-activity`,
    carServiceActivitySave:`${baseUrl}/api/v1/lead-squared/car-service-activity-save`,
    carServiceAttendance:`${baseUrl}/api/v1/lead-squared/car-service-attendance`,
    carServicePendingActivity:`${baseUrl}/api/v1/lead-squared/car-service-activity-pending`,
    carServiceIsCheckout:`${baseUrl}/api/v1/lead-squared/is-check-in`,
    carServiceOpportunity:`${baseUrl}/api/v1/lead-squared/car-service-opportunity`,
    carServiceAccount:`${baseUrl}/api/v1/lead-squared/car-service-account-save`,
    sitePocType:`${baseUrl}/api/v1/lead-squared/site-poc-type`,
    oemManufactureName:`${baseUrl}/api/v1/lead-squared/oem-manufacture-name`,
    carServiceAccountFilter:`${baseUrl}/api/v1/lead-squared/car-service-account-filter`,
    baOpportunity:`${baseUrl}/api/v1/lead-squared/save-ba-opportunity`,
    postClosure:`${baseUrl}/api/v1/lead-squared/post-closure`,
    lastCheckIn:`${baseUrl}/api/v1/lead-squared/last-check-in`,

    parkingSaveActivity:`${baseUrl}/api/v1/lead-squared/parking-activity`,
    parkingPendingActivity:`${baseUrl}/api/v1/lead-squared/parking-pending-activity`,
    parkingAttendance:`${baseUrl}/api/v1/lead-squared/parking-mark-attendance`,
    parkingAccountList:`${baseUrl}/api/v1/lead-squared/parking-account-details`,
    parkingAccountSave:`${baseUrl}/api/v1/lead-squared/save-parking-account`,

    baSaveActivity:`${baseUrl}/api/v1/lead-squared/ba-activity`,
    baPendingActivity:`${baseUrl}/api/v1/lead-squared/ba-pending-activity`,
    baAttendance:`${baseUrl}/api/v1/lead-squared/ba-mark-attendance`,
    baAccountList:`${baseUrl}/api/v1/lead-squared/ba-closed-leads`,
    accountByLeadId:`${baseUrl}/api/v1/lead-squared/account-by-lead-id`,

    SaveActivityByModule:`${baseUrl}/api/v1/lead-squared/save-activity-by-module`,
    pendingActivityByModule:`${baseUrl}/api/v1/lead-squared/pending-activity-by-module`,
    attendanceByModule:`${baseUrl}/api/v1/lead-squared/mark-attendance-by-module`,

    attendanceRequest:`${baseUrl}/api/v1/lead-squared/attendance-regularization`,
    attendanceRequestList:`${baseUrl}/api/v1/lead-squared/attendance-regularization-list`,

    journeySave:`${baseUrl}/api/v1/lead-squared/save-journey`,
    getJourney:`${baseUrl}/api/v1/lead-squared/get-user-journey`,

    createReferral:`${baseUrl}/api/v1/lead-squared/create-referral`,
    getDropdownProjectTypes:`${baseUrl}/api/v1/lead-squared/get-referral-project-types`,
    approveReferral:`${baseUrl}/api/v1/lead-squared/approve-referral`,
    getReferralDetails:`${baseUrl}/api/v1/lead-squared/get-referrals-details`,
    getReferralList:`${baseUrl}/api/v1/lead-squared/get-referrals-list`,
    getAccountsForCalling:`${baseUrl}/api/v1/lead-squared/get-sites-for-calling`,
    saveReferralCallForm:`${baseUrl}/api/v1/lead-squared/save-site-referral-call-log`,
    getReferralCallLogs:`${baseUrl}/api/v1/lead-squared/get-site-referral-call-logs`,
    getReferralCallFilters:`${baseUrl}/api/v1/lead-squared/get-site-referral-filters`,
    getPreviousActivities:`${baseUrl}/api/v1/lead-squared/get-last-three-activities`,
    checkDeviceId:`${baseUrl}/api/v1/lead-squared/check-device-id`,


    dashboardContent:`${baseUrl}/api/v1/lead-squared/dashboard-content`,
    heatMap:`${baseUrl}/api/v1/sales/heatmap/site-listing`,
    meetingBtId:`${baseUrl}/api/v1/lead-squared/meeting-data-by-id`,
    getAllLeads:`${baseUrl}/api/v1/lead-squared/get-leads`,
    getLeadDetails:`${baseUrl}/api/v1/lead-squared/get-lead-details`,
    getLeadFilters:`${baseUrl}/api/v1/lead-squared/lead-filters`,
    updateLeadStatus:`${baseUrl}/api/v1/lead-squared/update-lead-status`,
    updateLeadAccount:`${baseUrl}/api/v1/lead-squared/update-lead-account`,
    createNewLead:`${baseUrl}/api/v1/lead-squared/create-new-lead`,

    fetchPanDetails: `${baseUrl}/api/v1/lead-squared/fetch-customer-details`,
    
    fileUpload: {
        imageUpload: `${baseUrl}/api/v1/fileUpload/image`,
        imageUploadPublic: `${baseUrl}/api/v1/fileUpload/imagePublic`,
        docUpload: `${baseUrl}/api/v1/fileUpload/document`,
        excelUpload: `${baseUrl}/api/v1/fileUpload/excel`,
        mediaUpload: `${baseUrl}/api/v1/fileUpload/media`,
        docUploadPublic: `${baseUrl}/api/v1/fileUpload/documentPublic`,
        carnivalDocumentPublic: `${baseUrl}/api/v1/fileUpload/carnivalDocumentPublic`,
    },
    locations: {
        city: `${baseUrl}/api/v1/fetchCity`,
        zone: `${baseUrl}/api/v1/fetchZone?city_id=`,
        state: `${baseUrl}/api/v1/fetchGeoState`,
        area: `${baseUrl}/api/v1/fetchArea?zone_id=`,
        pinCode: `${baseUrl}/api/v1/fetchGeoCityStateOnPincode?pincode=`,
        locationType: `${baseUrl}/api/v1/sales/lead/locationTypes`,
        saveLocation: `${baseUrl}/api/v1/saveLocation`,
        getAllCity: `${baseUrl}/api/v1/lead-squared/get-city`,
    },

    internalGeocode: `${baseUrl}/api/v1/location/geo-location`,
    googleAPI: {
        placeSearch: `https://maps.googleapis.com/maps/api/js?key=AIzaSyCweWEGenU5sDidT_1MKho5VoAhMC4CgtQ&libraries=places`,
        geocode: `https://maps.googleapis.com/maps/api/geocode/`,
        iosMapNavDir: `maps://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=`,
        AndroidMapNavDir: `https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=`,
    },

    businessProject:`${baseUrl}/api/v1/business/infra-project`,
    businessSaveProject:`${baseUrl}/api/v1/business/save-business`,

    login:{
        ssoLogin:`${baseUrl}/api/v1/googleLogin`,
    },
    fileComplain: {
        createFdTickets: `${baseUrl}/api/v1/maintenance/create-issue-tickets`,
        fetchAllIssue: `${baseUrl}/api/v1/maintenance/fetch-issue-listing`,
    }
}

export default Config;